import { CoreModule } from 'src/app/@core/core.module';
import { Events } from 'src/app/@core/event.service';
import { ExternalReturnValue } from 'src/app/@core/types';

export type PageTrackEvent = {
  pageName: string;
  pageTitle: string;
};

export function PageTrack(explicitPageName?: string): ClassDecorator {
  return (c: ExternalReturnValue): void => {
    const { ionViewDidEnter } = c.prototype;

    // eslint-disable-next-line func-names
    c.prototype.ionViewDidEnter = function (...args: ExternalReturnValue[]): void {
      const events = CoreModule.injector.get(Events);

      const pageName = explicitPageName || this.pageTrackName;

      if (typeof pageName === 'string' && pageName) {
        events.publish('view:enter', {
          pageName,
          pageTitle: typeof this.pageTrackTitle === 'string'
            ? this.pageTrackTitle
            : '',
        });
      } else {
        console.error('PageTrack requires an explicit, stable page name.');
      }
      // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
      ionViewDidEnter && ionViewDidEnter.apply(this, args);
    };
  };
}
